import PropTypes from 'prop-types';
import { Component, createElement } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class FetchItem extends Component {
  state = {};

  componentDidMount() {
    const { fetchOnMount, fetchStatus } = this.props;
    if (!fetchStatus || fetchOnMount) {
      this._fetchItem();
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.fetching && nextProps.fetchStatus !== prevState.prevFetchStatus) {
      return {
        prevFetchStatus: null,
        fetching: false,
      };
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    const { entity, entityId, fetchStatus } = this.props;
    if ((entity !== prevProps.entity || entityId !== prevProps.entityId) && !fetchStatus?.success) {
      this._fetchItem();
    }
  }

  _fetchItem() {
    const { entityId, fetchAction, fetchKey, fetchParams, fetchStatus } = this.props;
    const { fetching } = this.state;
    if (fetching !== entityId) {
      this.setState({ fetching: entityId, prevFetchStatus: fetchStatus });
      fetchAction(entityId, fetchParams, fetchKey);
    }
  }

  render() {
    const { children, component, fetchStatus, item, itemProp = 'item' } = this.props;
    const { fetching } = this.state;

    const props = {
      [itemProp]: item,
      fetching: !(!fetching && fetchStatus),
      fetchError: fetchStatus && fetchStatus.error,
      fetchedAt: fetchStatus && fetchStatus.fetched_at,
      onRefetch: this._fetchItem,
    };
    if (component) {
      return createElement(component, props);
    }
    return children(props);
  }
}

FetchItem.propTypes = {
  children: PropTypes.func,
  component: PropTypes.any,
  entity: PropTypes.string.isRequired,
  entityId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  entitySelector: PropTypes.func,
  fetchAction: PropTypes.func.isRequired,
  fetchKey: PropTypes.string,
  fetchOnMount: PropTypes.bool, // forces fetch on mount
  fetchParams: PropTypes.object,
  itemProp: PropTypes.string,
  statusSelector: PropTypes.func,
};

export default connect(
  (state, { entity, entityId, entitySelector, fetchKey, statusSelector }) => {
    const item = entitySelector ? entitySelector(state[entity].items) : state[entity].items[entityId];
    return {
      item,
      fetchStatus:
        statusSelector ?
          statusSelector(item, state[entity].status)
        : state[entity].status[fetchKey || `fetch_${entityId}`],
    };
  },
  (dispatch, { fetchAction }) => ({
    fetchAction: bindActionCreators(fetchAction, dispatch),
  }),
)(FetchItem);
